export default "__VITE_ASSET__a5c7a672__"